import React, { useState } from "react";

import { Dialog, FormControl, DialogTitle, Select, DialogContent, DialogActions, Button, withStyles, MenuItem } from '@material-ui/core';
import { socket } from "../../../index";
import appTranslations from "../../sc-translate/appTranslations";
import * as actions from '../store/profileActions';
import { connect } from 'react-redux';
import { GET_TRANSLATIONS } from "../../../redis-constants";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const LanguageSelect = props => {
    const { classes, modalState, handleCloseLanguageSelect, onSaveSettings, activeCustomerID, translations, defaultLanguage } = props;
    const [value, setValue] = useState(defaultLanguage);

    const submitHandler = async _event => {
        if (socket && value) {
            socket.emit(GET_TRANSLATIONS, { LanguageKey: value });
        }
        await onSaveSettings({ DefaultLanguage: value, type: "DefaultLanguage", ActiveCustomerID: activeCustomerID });
        handleCloseLanguageSelect();
    };

    return (
        <Dialog open={modalState}
            onClose={handleCloseLanguageSelect}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["selected_language"] || "Select language"}</DialogTitle>
            <DialogContent>
                <FormControl className={classes.formControl} margin={"dense"}>
                    <Select
                        name="language"
                        label={translations['selected_language'] || 'Select language'}
                        margin={"dense"}
                        value={value}
                        fullWidth={true}
                        onChange={(event) => setValue(event.target.value)}
                    >
                        {(appTranslations ? appTranslations : []).map(option => (
                            <MenuItem key={option.code} value={option.code}>
                                {option.displayName} - {translations[option.displayName.toLowerCase()] || option.displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseLanguageSelect} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={submitHandler} variant="contained" className={classes.buttonDanger}>
                    {translations['submit'] || 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        defaultLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSaveSettings: params => dispatch(actions.saveSettings(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LanguageSelect));

